module.exports = __webpack_public_path__ + "znamenka-a-kozni-vyrustky_1_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/znamenka-a-kozni-vyrustky_1_before_tn.jpg
// module id = 1474
// module chunks = 0